import $ from 'jquery';

const defaults = {
  breakpoint: 1024,
  activatorWidth: 70,
};

// TODO: Make module name and class/constructor name consistent.
function MobileCtrl(element, options) {
  this.element = element;
  this.settings = { ...defaults, ...options };
  this.$roots = this.getRootMenus();
  this.onClick = $.proxy(this.onClick, this);
  this.addListeners();
  this.displayActiveMenus();
}

MobileCtrl.prototype = {
  getRootMenus() {
    return $('a.depth-1', this.element);
  },
  onClick(event) {
    const clickPosition = event.pageX;
    const viewportWidth = $(window).width();
    const isMobile = viewportWidth < this.settings.breakpoint;

    if (isMobile) {
      const clickedActivator = clickPosition >= (viewportWidth - this.settings.activatorWidth);
      if (clickedActivator) {
        $(event.currentTarget).toggleClass('expand');
        event.preventDefault();
      }
    }
  },
  displayActiveMenus() {
    $('.active-trail a.depth-1:not(.active)', this.element).addClass('expand');
  },
  addListeners() {
    this.$roots.bind('click', this.onClick);
  },
};

export default MobileCtrl;



// WEBPACK FOOTER //
// ./MenuCtrl.js